import React, {useState} from "react";
import {StyledTemplateSidebar} from "./TemplateSidebar.style";
import Button from "components/molecules/Button";
import imageIcon from "../../../../../assets/WebsiteBuilder/imageIcon.svg";
import colourIcon from "../../../../../assets/WebsiteBuilder/colourIcon.svg";
import TextSection from "./TextSection";
import ImagesSection from "./ImagesSection";
import ColoursSection from "./ColoursSection";

const TemplateSidebar = () => {
    const [activeTab, setActiveTab] = useState(0);
    return (
        <StyledTemplateSidebar>
            <ul className="tabs-wrap">
                <li>
                    <Button variant={activeTab !== 0 && "completed"} onClick={() => setActiveTab(0)}>
                        <span>Aa</span> Text
                    </Button>
                </li>
                <li>
                    <Button
                        variant={activeTab !== 1 && "completed"}
                        className={activeTab === 1 ? "active" : ""}
                        onClick={() => setActiveTab(1)}>
                        <img src={imageIcon} alt="icon" /> Images
                    </Button>
                </li>
                <li>
                    <Button
                        variant={activeTab !== 2 && "completed"}
                        className={activeTab === 2 ? "active" : ""}
                        onClick={() => setActiveTab(2)}>
                        <img src={colourIcon} alt="icon" /> Colour
                    </Button>
                </li>
            </ul>
            {activeTab === 0 && <TextSection />}
            {activeTab === 1 && <ImagesSection />}
            {activeTab === 2 && <ColoursSection />}
        </StyledTemplateSidebar>
    );
};

export default TemplateSidebar;
